import { createSelector } from 'redux-starter-kit';

export default {
  selected: createSelector(['workbenches.selected']),
  list: createSelector(['workbenches.list']),
};
